import { Entitlement } from '@aibees/shared/definition';
import { sortEntitlements } from '../utils/entitlement';
import { useBrowseProductEntitlementApi } from '@aibees/shared/api';

interface GroupedEntitlement {
  group: string;
  entitlements: Entitlement[];
}

interface ParentGroupedEntitlement {
  parent: string;
  groups: GroupedEntitlement[];
}

export function useSubscriptionEntitlements(): ParentGroupedEntitlement[] {
  const { data } = useBrowseProductEntitlementApi();
  const entitlements = data?.features || [];
  const sortedEntitlements = sortEntitlements(entitlements || []);

  const parentGroups: Record<string, Entitlement[]> = sortedEntitlements.reduce(
    (acc, ent) => {
      const parentKey = ent.metadata.parent || 'no-parent';
      if (!acc[parentKey]) acc[parentKey] = [];
      acc[parentKey].push(ent);
      return acc;
    },
    {} as Record<string, Entitlement[]>
  );

  return Object.entries(parentGroups).map(([parent, entList]) => {
    const groupMap: Record<string, Entitlement[]> = entList.reduce(
      (acc, ent) => {
        const groupKey = ent.metadata.group || 'no-group';
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(ent);
        return acc;
      },
      {} as Record<string, Entitlement[]>
    );

    const groups = Object.entries(groupMap).map(([group, ents]) => ({
      group,
      entitlements: ents,
    }));

    return { parent, groups };
  });
}
